import { makeMutationHook, makeQueryHook } from "utils/apolloUtils";

import { CREATE_SEAT_MAP } from "./mutations";
import {
  CreateSeatMap,
  CreateSeatMapVariables,
} from "./__generated__/mutations";
import { GET_SEAT_MAPS } from "./queries";
import { GetSeatMap, GetSeatMapVariables } from "./__generated__/queries";

export const useCreateSetMapMutation = makeMutationHook<
  CreateSeatMap,
  CreateSeatMapVariables
>(CREATE_SEAT_MAP);

export const useSetMapListQuery = makeQueryHook<
  GetSeatMap,
  GetSeatMapVariables
>(GET_SEAT_MAPS);
